import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { EngineeringService } from 'src/app/services/engineering/engineering.service';

@Component({
  selector: 'app-mdllist',
  templateUrl: './mdllist.component.html',
  styleUrls: ['./mdllist.component.css']
})
export class MdllistComponent implements OnInit {

  data: any;

  constructor(private engineeringServices : EngineeringService, private router : Router,
    private route: ActivatedRoute) { 

    }

  ngOnInit() {
    this.getMdlList();
  }

  getMdlList() {
    this.engineeringServices.getMdlList().subscribe(
      data => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  assignDrawing = function (id) {
    //alert(id);
    this.router.navigate(['/assigndrawing/' + id + '']);
  }

  editMdlItem = function (id) {
    alert("Implementation InProgress");
    //this.router.navigate(['/assigndrawing/' + id + '']);
  }
  searchmdlList(keyword){
    
    this.engineeringServices.searchmdl(keyword).subscribe(
    (data) =>{
      this.data=data;
      console.log(data);
    }
    );
  }


}
